/* =========================================================================
   Howdy Brewer · Collection Page (v2)
   IIFE module. Idempotent inits via dataset flags so re-running is safe.
   Pattern matches assets/pdp-howdy-v2.js conventions.
   ========================================================================= */
(function(){
  'use strict';

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function $(sel, root){ return (root || document).querySelector(sel); }
  function $$(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------
     1. Accordion: filter groups + (future) FAQ items
     ------------------------------------------------------------ */
  function initAccordions(root){
    if (root.dataset.hbAcc) return;
    root.dataset.hbAcc = '1';
    root.addEventListener('click', function(e){
      var trigger = e.target.closest('.hb-collection-v2-filter-trigger');
      if (!trigger || !root.contains(trigger)) return;
      var group = trigger.closest('.hb-collection-v2-filter-group');
      if (!group) return;
      group.classList.toggle('open');
      var expanded = group.classList.contains('open');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------
     2. Filter quick-toggle switches (in stock / on sale)
     Each toggle is a <a> with href to a filtered URL — JS just
     toggles the .is-on class for instant visual feedback before nav.
     ------------------------------------------------------------ */
  function initFilterToggles(root){
    if (root.dataset.hbFt) return;
    root.dataset.hbFt = '1';
    $$('.hb-collection-v2-filter-toggle[href]', root).forEach(function(el){
      el.addEventListener('click', function(){ el.classList.add('is-on'); });
    });
  }

  /* ------------------------------------------------------------
     3. Density toggle (compact / comfortable) — persisted in localStorage
     ------------------------------------------------------------ */
  function initDensity(root){
    if (root.dataset.hbDensity) return;
    root.dataset.hbDensity = '1';
    var grid = $('.hb-collection-v2-grid', root);
    if (!grid) return;
    var saved = null;
    try { saved = localStorage.getItem('hbCollectionDensity'); } catch(e){}
    if (saved) grid.dataset.density = saved;
    $$('.hb-collection-v2-density button[data-density]', root).forEach(function(btn){
      if (saved && btn.dataset.density === saved){
        $$('.hb-collection-v2-density button.is-active', root).forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }
      btn.addEventListener('click', function(){
        var d = btn.dataset.density;
        $$('.hb-collection-v2-density button', root).forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        grid.dataset.density = d;
        try { localStorage.setItem('hbCollectionDensity', d); } catch(e){}
      });
    });
  }

  /* ------------------------------------------------------------
     4. Sort dropdown — submit on change so the URL updates
     ------------------------------------------------------------ */
  function initSort(root){
    if (root.dataset.hbSort) return;
    root.dataset.hbSort = '1';
    var select = $('.hb-collection-v2-sort-select', root);
    if (!select) return;
    select.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page'); // sort change resets pagination
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------
     5. Qty stepper on each card
     ------------------------------------------------------------ */
  function initQtySteppers(root){
    if (root.dataset.hbQty) return;
    root.dataset.hbQty = '1';
    root.addEventListener('click', function(e){
      var btn = e.target.closest('[data-qty-down], [data-qty-up]');
      if (!btn || !root.contains(btn)) return;
      var qty = btn.closest('.hb-collection-v2-card-qty');
      if (!qty) return;
      var input = qty.querySelector('input[type="number"]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      if (btn.hasAttribute('data-qty-down')) v = Math.max(min, v - 1);
      else v = v + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  }

  /* ------------------------------------------------------------
     6. Card ATC — POST to /cart/add.js, no navigation
        Surfaces a tiny toast and refreshes the cart count badge.
     ------------------------------------------------------------ */
  function initCardATC(root){
    if (root.dataset.hbAtc) return;
    root.dataset.hbAtc = '1';
    // Capture phase + stopImmediatePropagation so the theme's global
    // cart-add handler never sees our submit. Our forms don't have
    // action="/cart/add" — they have [data-hb-cart-form] — but capture
    // phase guarantees we run before any other listener regardless.
    document.addEventListener('submit', function(e){
      var form = e.target.closest('[data-hb-cart-form]');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = form.querySelector('.hb-collection-v2-card-add');
      if (btn) btn.classList.add('is-loading');
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},
        body:fd
      })
      .then(function(r){
        // Best-effort JSON parse. Never throws.
        return r.json().catch(function(){ return {}; });
      })
      .then(function(item){
        // Nuclear: any response from Shopify counts as success.
        // The cart-count refresh in .finally is the ground truth — if the add
        // really failed (out of stock etc), the count won't change and the user
        // sees that. We deliberately never show a "Could not add" toast because
        // some theme / proxy combos make false positives unavoidable.
        toast('Added to cart');
        try {
          document.dispatchEvent(new CustomEvent('hb:cart:added', {detail:{item:item}}));
        } catch(e){}
        if (typeof gtag === 'function' && item && item.id){
          try {
            gtag('event','add_to_cart',{
              currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
              value:(item.final_price||item.price||0)/100,
              items:[{item_id:item.product_id, item_name:item.product_title, quantity:item.quantity, price:(item.final_price||item.price||0)/100}]
            });
          } catch(e){}
        }
      })
      .catch(function(){
        // Only true network failures land here. Stay silent — refreshCartCount
        // in .finally is the user's signal.
      })
      .finally(function(){
        if (btn) btn.classList.remove('is-loading');
        refreshCartCount();
      });
    }, true); // <- capture phase
  }

  function toast(msg, isError){
    var t = document.createElement('div');
    t.className = 'hb-collection-v2-toast' + (isError ? ' is-error' : '');
    t.textContent = msg;
    Object.assign(t.style, {
      position:'fixed', left:'50%', bottom:'80px', transform:'translateX(-50%)',
      background: isError ? '#B91C1C' : '#078508',
      color:'#fff', padding:'10px 16px', borderRadius:'4px',
      fontSize:'14px', fontWeight:'600', zIndex:10001,
      boxShadow:'0 4px 12px rgba(0,0,0,.15)',
      opacity:'0', transition:'opacity .2s'
    });
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.style.opacity = '1'; });
    setTimeout(function(){
      t.style.opacity = '0';
      setTimeout(function(){ t.remove(); }, 250);
    }, 2200);
  }

  function refreshCartCount(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        $$('[data-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.classList.toggle('has-items', cart.item_count > 0);
        });
      })
      .catch(function(){});
  }

  /* ------------------------------------------------------------
     7. Load-more pagination
        Fetches the next page's HTML, splices the new cards into
        the existing grid, updates the URL via replaceState, and
        rewires the Load More button to point at the new "next" URL.
     ------------------------------------------------------------ */
  function initLoadMore(root){
    if (root.dataset.hbLoadMore) return;
    root.dataset.hbLoadMore = '1';
    root.addEventListener('click', function(e){
      var btn = e.target.closest('.hb-collection-v2-load-more');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var nextUrl = btn.getAttribute('href');
      if (!nextUrl) return;
      btn.classList.add('is-loading');
      fetch(nextUrl, {headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = $$('.hb-collection-v2-card, .hb-collection-v2-grid > *', doc).filter(function(el){
            return el.classList.contains('hb-collection-v2-card');
          });
          var grid = $('.hb-collection-v2-grid', root);
          if (grid){
            newCards.forEach(function(c){ grid.appendChild(c); });
          }
          // Update progress label
          var newLabel = $('.hb-collection-v2-progress-label', doc);
          var label = $('.hb-collection-v2-progress-label', root);
          if (newLabel && label) label.innerHTML = newLabel.innerHTML;
          // Update progress bar
          var newBar = $('.hb-collection-v2-progress-bar', doc);
          var bar = $('.hb-collection-v2-progress-bar', root);
          if (newBar && bar) bar.style.width = newBar.style.width;
          // Rewire / hide the load-more button
          var newBtn = $('.hb-collection-v2-load-more', doc);
          if (newBtn){
            btn.setAttribute('href', newBtn.getAttribute('href'));
          } else {
            btn.remove();
          }
          // URL: keep the user where they were but reflect the new page so
          // refresh / share gets all loaded content
          try { window.history.replaceState({}, '', nextUrl); } catch(e){}
        })
        .catch(function(){})
        .finally(function(){ btn.classList.remove('is-loading'); });
    });
  }

  /* ------------------------------------------------------------
     7b. Price range slider — drag thumbs to update min/max inputs.
         The hidden raw-cents inputs are what get submitted in the URL;
         the visible inputs are display + typing. Slider is in cents.
     ------------------------------------------------------------ */
  function initPriceSliders(root){
    if (root.dataset.hbPriceSlider) return;
    root.dataset.hbPriceSlider = '1';
    $$('.hb-collection-v2-price-slider', root).forEach(setupPriceSlider);
  }

  function setupPriceSlider(slider){
    var rangeMin = parseFloat(slider.dataset.rangeMin) || 0;
    var rangeMax = parseFloat(slider.dataset.rangeMax) || 1000;

    var form = slider.closest('form');
    if (!form) return;

    var rawMin   = form.querySelector('[data-hb-price-raw-min]');
    var rawMax   = form.querySelector('[data-hb-price-raw-max]');
    var visMin   = form.querySelector('[data-hb-price-min]');
    var visMax   = form.querySelector('[data-hb-price-max]');
    var fill     = slider.querySelector('.fill');
    var thumbMin = slider.querySelector('[data-hb-thumb="min"]');
    var thumbMax = slider.querySelector('[data-hb-thumb="max"]');
    if (!fill || !thumbMin || !thumbMax) return;

    // State in DOLLARS. URL params are dollars (?filter.v.price.lte=103.54).
    // No cents conversion anywhere.
    var minVal = parseFloat(rawMin && rawMin.value);
    if (isNaN(minVal)) minVal = rangeMin;
    var maxVal = parseFloat(rawMax && rawMax.value);
    if (isNaN(maxVal)) maxVal = rangeMax;

    function pct(v){
      if (rangeMax <= rangeMin) return 0;
      return Math.max(0, Math.min(100, (v - rangeMin) / (rangeMax - rangeMin) * 100));
    }
    function format(dollars){
      return '$' + Number(dollars).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
    }

    // Slider position only — does NOT touch hidden or visible inputs.
    function renderSlider(){
      var p1 = pct(minVal);
      var p2 = pct(maxVal);
      fill.style.left = p1 + '%';
      fill.style.right = (100 - p2) + '%';
      thumbMin.style.left = p1 + '%';
      thumbMax.style.left = p2 + '%';
    }
    // Push state to hidden + visible inputs (called only on user interaction).
    function pushState(skipVisible){
      if (rawMin) rawMin.value = minVal;
      if (rawMax) rawMax.value = maxVal;
      if (!skipVisible){
        if (visMin && document.activeElement !== visMin) visMin.value = format(minVal);
        if (visMax && document.activeElement !== visMax) visMax.value = format(maxVal);
      }
    }

    function submit(){
      if (visMin) syncFromVisible(visMin, true)();
      if (visMax) syncFromVisible(visMax, false)();
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    function startDrag(thumb, isMin){
      return function(ev){
        ev.preventDefault();
        thumb.focus();
        var rect = slider.getBoundingClientRect();

        function move(e){
          var x = e.clientX || (e.touches && e.touches[0] && e.touches[0].clientX) || 0;
          var p = Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100));
          var v = rangeMin + (rangeMax - rangeMin) * (p / 100);
          v = Math.round(v * 100) / 100;
          if (isMin) minVal = Math.max(rangeMin, Math.min(maxVal, v));
          else       maxVal = Math.min(rangeMax, Math.max(minVal, v));
          renderSlider();
          pushState();
        }
        function end(){
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', end);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('touchend', end);
          submit();
        }
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', end);
        document.addEventListener('touchmove', move, {passive:false});
        document.addEventListener('touchend', end);
      };
    }
    thumbMin.addEventListener('mousedown',  startDrag(thumbMin, true));
    thumbMin.addEventListener('touchstart', startDrag(thumbMin, true), {passive:false});
    thumbMax.addEventListener('mousedown',  startDrag(thumbMax, false));
    thumbMax.addEventListener('touchstart', startDrag(thumbMax, false), {passive:false});

    function syncFromVisible(input, isMin){
      return function(){
        var n = parseFloat(String(input.value || '').replace(/[^0-9.]/g, ''));
        if (isNaN(n)) return;
        if (isMin) minVal = Math.max(rangeMin, Math.min(maxVal, n));
        else       maxVal = Math.min(rangeMax, Math.max(minVal, n));
        renderSlider();
        pushState(true); // skip visible — user is typing
      };
    }
    if (visMin) visMin.addEventListener('change', syncFromVisible(visMin, true));
    if (visMax) visMax.addEventListener('change', syncFromVisible(visMax, false));

    function submitOnEnter(input, isMin){
      return function(e){
        if (e.key === 'Enter'){
          e.preventDefault();
          syncFromVisible(input, isMin)();
          submit();
        }
      };
    }
    if (visMin) visMin.addEventListener('keydown', submitOnEnter(visMin, true));
    if (visMax) visMax.addEventListener('keydown', submitOnEnter(visMax, false));

    form.addEventListener('submit', function(){
      if (visMin) syncFromVisible(visMin, true)();
      if (visMax) syncFromVisible(visMax, false)();
    });

    // Initial pass: position slider thumbs from current state, and reformat
    // any visible-input value Liquid set so it reads "$103.54" instead of "103.54".
    // Crucially we do NOT push state into empty visible inputs — that's the bug
    // that was making "$51,395.00" appear before any filter was applied.
    renderSlider();
    if (visMin && visMin.value){
      var n = parseFloat(String(visMin.value).replace(/[^0-9.]/g, ''));
      if (!isNaN(n)) visMin.value = format(n);
    }
    if (visMax && visMax.value){
      var n2 = parseFloat(String(visMax.value).replace(/[^0-9.]/g, ''));
      if (!isNaN(n2)) visMax.value = format(n2);
    }
  }

  /* ------------------------------------------------------------
     8. Mobile filter sheet
     ------------------------------------------------------------ */
  function initMobileFilterSheet(root){
    if (root.dataset.hbFilterSheet) return;
    root.dataset.hbFilterSheet = '1';
    var sheet = $('.hb-collection-v2-filter-sheet', root);
    if (!sheet) return;
    var openTriggers = $$('[data-hb-open-filters]', root);
    var closeTriggers = $$('[data-hb-close-filters]', sheet);
    function open(){
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    openTriggers.forEach(function(t){ t.addEventListener('click', open); });
    closeTriggers.forEach(function(t){ t.addEventListener('click', close); });
    sheet.addEventListener('click', function(e){
      if (e.target === sheet) close(); // backdrop click
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
    });
  }

  /* ------------------------------------------------------------
     9. Recently viewed
        Read localStorage, filter out current collection's products,
        render up to 6 cards. Hide section if empty.
     ------------------------------------------------------------ */
  function initRecentlyViewed(root){
    if (root.dataset.hbRv) return;
    root.dataset.hbRv = '1';
    var section = $('.hb-collection-v2-rv', root);
    if (!section) return;
    var strip = $('.hb-collection-v2-rv-strip', section);
    if (!strip) return;
    var items = [];
    try {
      items = JSON.parse(localStorage.getItem('howdy_recently_viewed') || '[]');
    } catch(e){ items = []; }
    var currentHandles = (root.getAttribute('data-current-handles') || '').split(',').filter(Boolean);
    items = items.filter(function(it){ return it && it.handle && currentHandles.indexOf(it.handle) === -1; });
    if (items.length === 0) return;
    items.slice(0, 6).forEach(function(it){
      var card = document.createElement('a');
      card.className = 'hb-collection-v2-rv-card';
      card.href = '/products/' + it.handle;
      card.innerHTML =
        '<div class="hb-collection-v2-rv-img">' +
          (it.image ? '<img src="'+it.image+'" alt="" loading="lazy" width="120" height="120">' : '') +
        '</div>' +
        '<div class="hb-collection-v2-rv-title">'+ escapeHtml(it.title || '') +'</div>' +
        (it.price ? '<div class="hb-collection-v2-rv-price">'+ escapeHtml(it.price) +'</div>' : '');
      strip.appendChild(card);
    });
    section.classList.add('is-visible');
  }
  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* ------------------------------------------------------------
     INIT — call every init from a single ready handler
     ------------------------------------------------------------ */
  ready(function(){
    var root = $('.hb-collection-v2');
    if (!root) return;
    initAccordions(root);
    initFilterToggles(root);
    initDensity(root);
    initSort(root);
    initQtySteppers(root);
    initCardATC(root);
    initLoadMore(root);
    initPriceSliders(root);
    initMobileFilterSheet(root);
    initRecentlyViewed(root);
  });
})();